import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-select-check-all',
  templateUrl: './select-check-all.component.html',
  styleUrls: ['./select-check-all.component.scss']
})
export class SelectCheckAllComponent {
  @Input() control: UntypedFormControl;
  @Input() values: any[] = [];

  isChecked(): boolean {
    if (this.values?.length && this.control.value?.length) {
        return this.control.value.length === this.values.length &&
            this.values.every(value => this.control.value?.find(v => v.id === value.id));
    }
    return false;
    // return this.control?.value?.length && this.values?.length
    //   && this.values.every(value => this.control.value.find(v => v.id === value.id));
  }

  isIndeterminate(): boolean {
    if (this.values?.length && this.control.value?.length) {
        if (this.values.length !== this.control.value.length) {
            return true;
        } else {
            return !this.values.every(value => this.control.value.find(v => v.id === value.id));
        }
    }
    return false;
    // must use !! to avoid returning 0 instead of false
    // return !!(this.control?.value?.length && this.values?.length)
    //   && !this.values.every(value => this.control.value.find(v => v.id === value.id));
  }

  toggleSelection(change: MatCheckboxChange): void {
    if (change.checked) {
      if (this.control.value?.length) {
        const valuesToAdd = this.values.filter(value => !this.control.value.find(cV => cV.id === value.id));
        this.control.setValue([...this.control.value, ...valuesToAdd]);
      } else {
        this.control.setValue(this.values);
      }
    } else {
      // remove values visible in control (exemple in select with multiple selection enabled when filtered)
      const newValues = this.control.value?.filter(value => !this.values.find(v => v.id === value.id));
      this.control.setValue(newValues);
    }
  }

}
